export default __webpack_public_path__ + "static/media/Section2-marker.ef210094.svg";